module.exports = __webpack_public_path__ + "static/media/step-7-face.e0c9e46b.gif";